import PhotoSwipe from 'photoswipe';
import PhotoSwipeDefaultLayout from 'photoswipe/dist/photoswipe-ui-default';

import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

(() => {
    const pswp = document.querySelector('.pswp');
    const videoButton = document.querySelector('[data-video-button]');
    const iframeButton = document.querySelector('[data-iframe-button]');

    if (pswp && videoButton) {
        videoButton.addEventListener('click', async () => {
            let data;
            const { url } = videoButton.dataset;

            if (url.includes('embed')) {
                data = {
                    html: `<iframe src="${url}"></iframe>`,
                };
            }

            if (Boolean(data) === false && url.includes('youtube')) {
                const response = await fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`);
                data = await response.json();
            }

            if (Boolean(data) === false && url.includes('vimeo')) {
                const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`);
                data = await response.json();
            }

            const items = [
                {
                    html: `
                        <div class="pswp-video">
                            <div class="video-wrapper">
                                ${data && data.html}
                            </div>
                        </div>
                    `,
                },
            ];

            const photoSwipe = new PhotoSwipe(
                pswp,
                PhotoSwipeDefaultLayout,
                items,
            );

            photoSwipe.init();
        });
    }

    if (pswp && iframeButton) {
        iframeButton.addEventListener('click', () => {
            const items = [
                {
                    html: `
                        <div class="pswp-iframe">
                            <iframe src="${iframeButton.dataset.url}" />
                        </div>
                    `,
                },
            ];

            const photoSwipe = new PhotoSwipe(
                pswp,
                PhotoSwipeDefaultLayout,
                items,
            );

            photoSwipe.init();
        });
    }
})();
